import React, { useState } from 'react';
import { X, ArrowRightLeft, ChevronDown } from 'lucide-react';
interface RetentionModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedCount: number;
  onConfirm: (processor: string, loa: string) => void;
}
export function RetentionModal({
  isOpen,
  onClose,
  selectedCount,
  onConfirm
}: RetentionModalProps) {
  const [processor, setProcessor] = useState('');
  const [loa, setLoa] = useState('');
  if (!isOpen) return null;
  const processors = ['Eli Vance', 'Marcus Johnson', 'Sarah Jenkins'];
  const loas = ['Soroki V.', 'James Miller', 'Taylor Swift'];
  const handleConfirm = () => {
    if (processor && loa) {
      onConfirm(processor, loa);
      setProcessor('');
      setLoa('');
    }
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-202">
      <div className="absolute inset-0 bg-gray-900/40 backdrop-blur-sm" onClick={onClose} data-id="element-203"></div>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative z-10" data-id="element-204">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-205">
          <div className="flex items-center gap-3" data-id="element-206">
            <div className="bg-blue-50 text-blue-600 p-2 rounded-xl" data-id="element-207">
              <ArrowRightLeft className="w-5 h-5" data-id="element-208" />
            </div>
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-209">
              Reassign to Retention
            </h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-1.5 rounded-lg transition-colors" data-id="element-210">
            <X className="w-5 h-5" data-id="element-211" />
          </button>
        </div>
        <div className="p-6" data-id="element-212">
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-6 flex items-center justify-between" data-id="element-213">
            <span className="text-sm font-medium text-gray-600" data-id="element-214">
              Selected Loans
            </span>
            <span className="bg-gray-900 text-white text-xs font-bold px-2.5 py-1 rounded-full min-w-[28px] text-center" data-id="element-215">
              {selectedCount}
            </span>
          </div>
          <div className="space-y-4" data-id="element-216">
            <div data-id="element-217">
              <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-218">
                Retention Processor
              </label>
              <div className="relative" data-id="element-219">
                <select value={processor} onChange={e => setProcessor(e.target.value)} className="w-full appearance-none px-3 py-2.5 pr-10 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 shadow-sm cursor-pointer" data-id="element-220">
                  <option value="" disabled data-id="element-221">
                    Select a processor...
                  </option>
                  {processors.map(p => <option key={p} value={p} data-id="element-222">
                      {p}
                    </option>)}
                </select>
                <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-223" />
              </div>
            </div>
            <div data-id="element-224">
              <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-225">
                Retention LOA
              </label>
              <div className="relative" data-id="element-226">
                <select value={loa} onChange={e => setLoa(e.target.value)} className="w-full appearance-none px-3 py-2.5 pr-10 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 shadow-sm cursor-pointer" data-id="element-227">
                  <option value="" disabled data-id="element-228">
                    Select an LOA...
                  </option>
                  {loas.map(l => <option key={l} value={l} data-id="element-229">
                      {l}
                    </option>)}
                </select>
                <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-230" />
              </div>
            </div>
          </div>
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-end gap-3 bg-gray-50/50 rounded-b-2xl" data-id="element-231">
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-232">
            Cancel
          </button>
          <button onClick={handleConfirm} disabled={!processor || !loa} className="px-5 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed rounded-lg transition-colors shadow-sm" data-id="element-233">
            Assign to Retention
          </button>
        </div>
      </div>
    </div>;
}